import React, { useEffect, useState } from "react";
import { ISaasquatchProps } from "./types";
import { useIsInView } from "../../hooks/useIsInView";
import { isClientSideRendering } from "../../helpers/rendererType";
import { LoaderFormQuestion } from "../HubSpot/HubSpotForm/loader";

const Saasquatch: React.FC<ISaasquatchProps> = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const containerId = `saasquatch-${props.index}`;

  const { ref, isInView } = useIsInView();
  const [hasWidgetLoaded, setWidgetLoaded] = useState(false);

  if (isClientSideRendering()) {
    const [scriptLoaded, setScriptLoaded] = useState(
      typeof window.squatch !== "undefined",
    );

    useEffect(() => {
      if (isInView && !scriptLoaded) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
        const scriptjs = require("scriptjs"); // Prevent build errors on the server as we only need it on the front-end
        const scriptUrl = "https://fast.ssqt.io/squatch-js@2"; // We want to lazy load it

        window.squatchTenant = props.saasquatchTenantAlias;
        scriptjs.get(scriptUrl, () => {
          setScriptLoaded(true);
          setWidgetLoaded(true);
        });
      }
    }, [isInView, scriptLoaded]);
  }

  return (
    <>
      <squatch-embed widget={props.saasquatchWidgetType} id={containerId} data-testid="saasquatch-form" />
      {!hasWidgetLoaded
      && (
      <div ref={ref} data-testid="saasquatch-form-loading">
        <div
          data-testid="loading-component"
          role="alert"
          aria-live="polite"
          aria-busy="true"
        >
          <p hidden>Loading...</p>
          <LoaderFormQuestion numberOfQuestions={1} />
        </div>
      </div>
      )}
    </>
  );
};

export { Saasquatch };
